import React from "react";
import withStyles, { createUseStyles } from "react-jss";
import { CheckBox } from "ComponentsUI/Buttons";

const useStyles = createUseStyles((theme) => ({
	root: {
		display: "flex",
		justifyContent: "flex-end",
		marginBottom: "50px",
		flexGrow: 1,
	},
	block: {
		display: "flex",
		alignItems: "flex-end",
	},
	blockWrapper: {
		display: "flex",
		alignItems: "center",
		marginRight: "10px",
		cursor: "pointer",
	},
	smallText: {
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		lineHeight: 1,
		color: theme.palette.colors.darkSlateBlue,
		marginRight: "10px",
	},
	bigText: {
		fontFamily: theme.fonts.bold,
		fontSize: "18px",
		lineHeight: 1,
		color: theme.palette.colors.darkSlateBlue,
		marginLeft: "16px",
	},
	question: {
		lineHeight: 0,
		cursor: "pointer",
		"& span": {
			fontSize: "16px",
			color: theme.palette.colors.cloudyBlue,
		},
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		root: {
			marginBottom: "50px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			marginBottom: "40px",
			marginTop: "0px",
		},
		smallText: {
			fontSize: "14px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			marginBottom: "16px",
			marginTop: "0px",
			flexWrap: "wrap",
		},
		block: {
			width: "100%",
			"&:first-child": {
				marginBottom: "16px",
			},
		},
		smallText: {
			fontSize: "14px",
		},
		bigText: {
			fontSize: "16px",
			marginLeft: "6px",
		},
	},
}));

const InfoContainer = (props) => {
	const classes = useStyles();
	const texts = props.texts;

	return (
		<div className={classes.root}>
			{/*<div className={classes.block}>*/}
			{/*    {false && (*/}
			{/*        <div className={classes.blockWrapper}>*/}
			{/*            <CheckBox active={true}/>*/}
			{/*            <div className={classes.bigText}>*/}
			{/*                {texts.ONLY_LEGAL_REVIEWS}*/}
			{/*            </div>*/}
			{/*        </div>*/}
			{/*    )}*/}
			{/*    {false && (*/}
			{/*        <Tooltip*/}
			{/*            position={`top`}*/}
			{/*            header={<TooltipHeader text={"123"}/>}*/}
			{/*            body={<TooltipBody> {"1234"} </TooltipBody>}*/}
			{/*        >*/}
			{/*                <span className={classes.question}>*/}
			{/*                    <span className="icon24 icon-question"/>*/}
			{/*                </span>*/}
			{/*        </Tooltip>*/}
			{/*    )}*/}
			{/*</div>*/}
			<div className={classes.block}>
				<div className={classes.smallText}>{texts.ratingBelieveTheRating}</div>
				<span className={classes.question} onClick={props.onClickQuestion}>
					<span className="icon24 icon-question" />
				</span>
			</div>
		</div>
	);
};

export default InfoContainer;
